//Componentes generales
import React, { useContext, useEffect, useRef, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from 'reactstrap';
  
// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark
} from "@fortawesome/free-solid-svg-icons";

//Tipos de Estado
import { ifState } from '../../utils/states';

//Estilos
import './StateChange.css';

// Alertas
import Swal from 'sweetalert2'
import ModalFormLectura from "../modalForm/ModalFormLectura";
import activoContext from "../../context/activoContex/activoContex";
import { getNewFormattedDate, modelateUniMed } from "../../utils/funciones";
import useLoading from "../../customHooks/useLoading";
import authContext from "../../context/authentication/authContex";

/* 
    Componente de vista de dialogo de cambio de estado.
        Donde item es el requerimiento a modificar el requerimiento.
              guardarEstado es la función del context que guarda la modificación.
              cerrar es la función encargada de ocultar el dialogo.
*/
function StateChange({ item, guardarEstado, cerrar, currentUser }) {

    const {globalSettings} = useContext(authContext);

    //state del requerimiento.
    const [req, setReq] = useState(item);
    const [showModalLectura,setShowModalLectura] = useState(false);
    //States para el dropdown
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const aContext = useContext(activoContext);
    const {loading, setLoading} = useLoading(false);
    const {activoList, getLastLecturaByUnidadAndActivo, addLectura, getLectsByActivoId, actualizarProcProgramado, calcularMantenimientoByActivo, procsProgramadosList} = aContext;

    const uniMedToAsk = useRef(null);
    const uniMedsToAsk = useRef(null);
    const titleModalLectura = useRef(null);

    /* 
        Función encargada de guardar la modificación del requerimiento y lanzar una alerta.
            Donde r es el requerimiento con el nuevo estado.
    */
    const saveReq = async (r) => {
        const resp = await guardarEstado(r, r.state);
        
        Swal.fire(
            `Nuevo Estado: ${(r.state == 'ENPROCESO') ? 'EN PROCESO' :r.state}`,
            'El Estado fue Modificado Correctamente' ,
            'success'
        );
        cerrar(null);
        setLoading(false);
        return resp;
    }

    const validate = ({tareasDoneChecked = false, materialesChecked = false, imputacionesChecked = false, tareasChecked = false, checklistsChecked = false, proveedoresChecked = false}) =>{
        if(req.tareas.length > 0 && req.tareas.find(t => t.done == false) && !tareasDoneChecked){
            return {msg:`La ODT ${req.tDocNroFor} poseé Tareas sin completar. Está seguro que desea darla por Finalizada ?? `, tareasDoneChecked: true, materialesChecked: false, imputacionesChecked: false, proveedoresChecked:false, tareasChecked: false};
        }
        else if(req.products != undefined && req.products.length == 0 && !materialesChecked){
            if(globalSettings.ODTmustHaveComponents){
                return {msg:`No se permite dar por Finalizada una ODT sin Materiales`, tareasDoneChecked: tareasDoneChecked, materialesChecked: true, imputacionesChecked: imputacionesChecked, proveedoresChecked: proveedoresChecked, tareasChecked: tareasChecked, code:'EXIT'};
            }else{
                return {msg:`La ODT ${req.tDocNroFor} no poseé Materiales. Está seguro que desea darla por Finalizada ?? `, tareasDoneChecked: tareasDoneChecked, materialesChecked: true, imputacionesChecked: imputacionesChecked, proveedoresChecked: proveedoresChecked, tareasChecked: tareasChecked};
            }
        }
        else if(req.imputaciones != undefined && req.imputaciones.length == 0 && !imputacionesChecked){
            if(globalSettings.ODTmustHaveRRHH){
                return {msg:`No se permite dar por Finalizada una ODT sin Imputaciones RRHH`, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: true, proveedoresChecked: proveedoresChecked, tareasChecked: tareasChecked, code:'EXIT'};
            }else{
                return {msg:`La ODT ${req.tDocNroFor} no poseé Imputaciones RRHH. Está seguro que desea darla por Finalizada ?? `, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: true, proveedoresChecked: proveedoresChecked, tareasChecked: tareasChecked};
            } 
        }else if(req.proveedores != undefined && req.proveedores == 0 && !proveedoresChecked){
            if(globalSettings.ODTmustHaveSuppliers){
                return {msg:`No se permite dar por Finalizada una ODT sin Servicios de Terceros`, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: imputacionesChecked, tareasChecked: tareasChecked, proveedoresChecked: true, code:'EXIT'};
            }else if(globalSettings.ODTcouldHaveRRHHorSuppliers && req.imputaciones.length == 0){
                return {msg:`Para poder finalizar una ODT esta debe poseer o Imputaciones RRHH o Servicios de Terceros.`, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: imputacionesChecked, tareasChecked: tareasChecked, proveedoresChecked: true, code:'EXIT'};
            } else{
                return {msg:`La ODT ${req.tDocNroFor} no poseé Servicios de Terceros. Está seguro que desea darla por Finalizada ?? `, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: imputacionesChecked, proveedoresChecked: true, tareasChecked: tareasChecked};
            } 
        }else if(req.checklists && Array.isArray(req.checklists) && req.checklists.length > 0 && req.checklists.some(c => c.nroChecklist == 0) && !checklistsChecked){
            return {msg:`La ODT ${req.tDocNroFor} poseé checklists sin realizar. Está seguro que desea darla por Finalizada ?? `, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: imputacionesChecked, proveedoresChecked: proveedoresChecked, tareasChecked: tareasChecked, checklistsChecked:true};
        }else if(req.tareas.length == 0 && !tareasChecked){
            return {msg:`No se permite dar por Finalizada una ODT sin TAREAS`, tareasDoneChecked: tareasDoneChecked, materialesChecked: materialesChecked, imputacionesChecked: imputacionesChecked, proveedoresChecked: proveedoresChecked, tareasChecked: true, code:'EXIT'};
        }else{
            return {msg:''};
        }
    }

    const handleSaveReq = async(req, validationObj = {tareasDoneChecked: false, materialesChecked: false, imputacionesChecked: false, tareasChecked: false}) => {
        setLoading(true);
        if(req.state == "FINALIZADA"){
            const msgObject = validate(validationObj);
            if(msgObject.code == undefined){
                if(msgObject.msg != ''){
                    let result = await Swal.fire({
                        title: `Ops!`,
                        icon: 'warning',
                        text: msgObject.msg,
                        showConfirmButton: true,
                        showCancelButton: true, // Habilita el botón de cancelar
                        confirmButtonColor: '#ff0000',
                        denyButtonColor: '#3d4d87',
                        confirmButtonText: 'Sí, estoy seguro',
                        cancelButtonText:'No',
                        allowEnterKey: true
                    })
                    if (result.isConfirmed ) {
                        const {msg, ...validation} = msgObject;
                        await handleSaveReq(req,validation);
                    }
                }else{
                    switch(item.activoCompleto.solicitaLecturaODT){
                        case 'SIEMPRE':
                            uniMedsToAsk.current = [modelateUniMed(item.activoCompleto.DEFAULTUNIMED), ...(item.activoCompleto.DEFAULTUNIMED2 ? [modelateUniMed(item.activoCompleto.DEFAULTUNIMED2)] : [])];

                            let firstLectureToAsk = uniMedsToAsk.current.shift();
                            uniMedToAsk.current = firstLectureToAsk;

                            setShowModalLectura(true);
                            break;
                        case 'NUNCA':
                            handleMinimizarModalLectura(true, "");
                            break;
                        case 'DEFAULTUNIMED':
                            if(req.uniMeds.some(um => (um.value == item.activoCompleto.DEFAULTUNIMED || um.value == item.activoCompleto.DEFAULTUNIMED2))){
                                uniMedsToAsk.current = req.uniMeds.filter(um => ((um.value == item.activoCompleto.DEFAULTUNIMED || um.value == item.activoCompleto.DEFAULTUNIMED2) && um.value != 'DAYS'));
                                let firstLectureToAsk = uniMedsToAsk.current.shift();
                                uniMedToAsk.current = firstLectureToAsk;
                                setShowModalLectura(true);    
                            } 
                            else handleMinimizarModalLectura(true, "");
                            break;
                        default: //Controla que sucede si activo no tiene solicitaLecturaODT seteado.
                            setShowModalLectura(true);
                            break;
                    }
                } 
            }else{
                Swal.fire({
                    title: `Ops!`,
                    icon: 'error',
                    text: msgObject.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#ff0000',
                    confirmButtonText: 'Entendido',
                    allowEnterKey: true
                })
            }
        }else{
            await saveReq(req);
        }
    }

    //Al recibir la lectura de cierre, finaliza la ODT y envia su estado al Backend para modificarla.
    const handleMinimizarModalLectura = async(flag, accion) =>{
        if(accion == 'close'){
            //cerrar();
            setLoading(false);
        }
        if(flag){
            if((uniMedsToAsk?.current?.length > 0)){
                titleModalLectura.current = 'Añadir Segunda Lectura'
                uniMedToAsk.current = uniMedsToAsk.current.shift();
                
                setShowModalLectura(false);
                Swal.fire({
                    timer: 1000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => Swal.showLoading()
                }).then(() => {
                    setShowModalLectura(true);
                });
                return;
            } 

            saveReq(req);
        }
        setShowModalLectura(false);
    }

    const handleChange = (itemType, prop='state') =>{
        setReq({ ...req, state: 'FINALIZADA', fechaCompletado: getNewFormattedDate()});
        if(itemType == 'FINALIZADA' && req.activoCompleto != undefined && item.uniMed.value != 'DAYS'){
           // setShowModalLectura(true);
        }else if(itemType == 'FINALIZADA' && item.uniMed.value == 'DAYS'){
            //Revisar aunque nunca se cumpla esta condicion ya que item viene modelado desde el backend teniendo en cuenta las propiedades necesarias para StateChange y ModalFormLectura.            
        }else{
            setReq({ ...req, [prop]: prop == 'fechaCompletado' ? getNewFormattedDate(itemType) : itemType})
        }
    }

    useEffect(()=>{
        let newReq = {...req};
        let activoModificado = req.activoCompleto;
        activoModificado = {...activoModificado, DEFAULTUNIMED: modelateUniMed(activoModificado.DEFAULTUNIMED)};
        newReq = {...newReq, activoCompleto: activoModificado};
        setReq(newReq);
    },[item]);

    return (
        <div className='container-gr-state'>
            <button className="minimizarBtn label-state-icon-r" onClick={() => cerrar(null)}>X</button>
            <div className='container-state'>
                <div className="label-state-data">
                    {req.tDocCodFor + ' - ' + req.tDocNroFor + ' . Estado Actual: ' +item.state}
                </div>
                <div className="container-state-list">
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" className='dropdown-userTypes'>
                            <DropdownToggle caret>{req.state === '' ? 'Seleccione un estado' : (req.state == 'ENPROCESO') ? 'EN PROCESO' : req.state}</DropdownToggle>
                            <DropdownMenu>
                                {ifState(item.state, currentUser).map(function (itemType, index) {
                                    return (
                                        <article key={itemType}>
                                            <DropdownItem onClick={() => handleChange(itemType)}>{(itemType == 'ENPROCESO') ? 'EN PROCESO' : itemType}</DropdownItem>
                                        </article>
                                    );
                                })}
                            </DropdownMenu>
                    </Dropdown>
                    {req.state == 'FINALIZADA' && <div className="inputGroup">
                        <label>Fecha Completado</label>
                        <input disabled={!globalSettings?.allowChooseEndDateODT} className="fechaCompletadoInput" type="datetime-local" onChange={(e) => handleChange(e.target.value,'fechaCompletado')} value={req.fechaCompletado} name="fechaCompletado" placeholder="fechaCompletado"/>
                    </div>}
                </div>
                <div className='btn-state-container'><button disabled={loading} className={`btn-state ${loading ? 'disabled' : ''}`} onClick={()=>handleSaveReq(req)}>Cambiar Estado</button></div>
                {
                    showModalLectura && <div className="modalFormContainer">
                        <ModalFormLectura activo={req.activoCompleto} usuario={currentUser} index={0} minimizar={handleMinimizarModalLectura} getLastLecturaByUnidadAndActivo={getLastLecturaByUnidadAndActivo} addLectura={addLectura} getLectsByActivoId={getLectsByActivoId} calcularMantenimientoByActivo={calcularMantenimientoByActivo} componentePadre="StateChange" fechaCompletado={req.fechaCompletado} firstRender={true} uniMedToAsk={uniMedToAsk.current} title={titleModalLectura.current}/>
                </div>
                }
            </div>
        </div>
    );
}

export default StateChange